module.exports = __webpack_public_path__ + "static/media/print.e8a4b694.svg";